import {
  Bestellung,
  BPNachbestellenBeginnenRequest,
  RemoteResult,
  ServiceAnfordernRequest,
  NachbestellungPending,
  Serviceanforderung as ServiceanforderungDto,
  LoadState,
} from "mangdto"
import router from "@/router"
import store from "@/store"
import Poster from "@/util/poster"
import RestPaths from "@/util/rest_paths"
import RouteNames from "@/util/route_names"
import { SocketMessageType } from "mangutil"
import Formatter from "../formatter"
import BaseLogic from "../base_logic"

export default class DetailsSofortLogic extends BaseLogic {
  bestellung: Bestellung = null
  service: Serviceanforderung = null
  serviceDialogVisible: boolean = false
  serviceLoadState: LoadState = LoadState.Idle

  serviceanforderungErstellen() {
    this.service = new Serviceanforderung()
    this.serviceDialogVisible = true
  }

  serviceAbsenden() {
    this.serviceLoadState = LoadState.Loading

    var request = new ServiceAnfordernRequest()
    request.bestellungId = this.bestellung.id
    request.kommentare = this.service.kommentare
    request.rechnungAnfordern = this.service.rechnungAnfordern

    Poster.postUser<RemoteResult<ServiceanforderungDto>>(
      RestPaths.bestellungKundeServiceAnfordern,
      request,
    )
      .then((response) => {
        if (response.data.success) {
          this.serviceLoadState = LoadState.Completed

          this.serviceDialogVisible = false
          this.mainLogic.bestellung.sofort.serviceanforderungen.push(
            response.data.payload,
          )
        } else {
          this.serviceLoadState = LoadState.Error
        }
      })
      .catch(() => {
        this.serviceLoadState = LoadState.Error
      })
  }

  berechneGesamtpreis(): number {
    var artikellistepreis = Formatter.berechnePreisListe(
      this.bestellung.artikelliste,
    )
    return artikellistepreis
  }

  berechneGesamtpreisTrinkgeld(): number {
    var gesamtpreis = this.berechneGesamtpreis()

    var trinkgeld = this.bestellung.trinkgeld
    if (trinkgeld != null) {
      gesamtpreis = gesamtpreis + trinkgeld
    }
    return gesamtpreis
  }

  init() {
    this.bestellung = this.mainLogic.bestellung
    this.mainLogic.bestellungListeners.push(() => {
      this.bestellung = this.mainLogic.bestellung
    })

    store.watch(
      (state) => state.incomingMessage,
      (newValue) => {
        if (!newValue) return
        if (!(newValue.type == SocketMessageType.ANFORDERUNG_STATUS_UPDATE))
          return
        var payload = JSON.parse(newValue.payload)
        this.bestellung.sofort.serviceanforderungen.forEach((s) => {
          if (s.id == payload.id) {
            s.status = payload.status
          }
        })
      },
    )
  }

  serviceAnfordern() {
    router.push({ name: RouteNames.BESTELLUNG_PAGE.SERVICE_ANFORDERN })
  }

  nachbestellen() {
    var request = new BPNachbestellenBeginnenRequest()
    request.bestellungId = this.bestellung.id

    Poster.postUser<RemoteResult<string>>(
      RestPaths.bestellungpendingNachbestellenBeginnen,
      request,
    ).then((response) => {
      if (response.data.success) {
        this.mainLogic.bestellung.nachbestellungPending =
          new NachbestellungPending()
        this.mainLogic.bestellung.nachbestellungPending.id =
          response.data.payload
        router.push({ name: RouteNames.BESTELLUNG_PAGE.NACHBESTELLEN.PRODUKTE })
      }
    })
  }

  bezahlen() {
    router.push({ name: RouteNames.BESTELLUNG_PAGE.BEZAHLEN })
  }
}

class Serviceanforderung {
  rechnungAnfordern: boolean = false
  kommentare: string
}
